import baseAPI from '@/api/base';
import {
  EditPoster,
  GetPoster,
  RegisterPoster,
} from '@/dtos/poster.dto';
import {
  DELETE_POSTER_URL,
  EDIT_POSTER_URL,
  GET_POSTER_URL,
  REGISTER_POSTER_URL,
  TOGGLE_POSTER_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Poster {
  static getPosters = async (
    getPoster: GetPoster
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_POSTER_URL, {
      params: getPoster,
    });
    console.log('response', response);
    return response;
  };

  static registerPoster = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_POSTER_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    console.log('response', response);
    return response;
  };

  static editPoster = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_POSTER_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  static togglePosterIsActive = async (
    editPoster: EditPoster
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_POSTER_IS_ACTIVE_URL,
      {
        ...editPoster,
      }
    );
    return response;
  };

  static deletePoster = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_POSTER_URL}/${id}`
    );
    return response;
  };
}

export default Poster;
